module.exports = __webpack_public_path__ + "static/media/thunder.4cee58ca.svg";